import { ReviewSliderItemInterface } from '@/types/newTypes'
import React from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import { EffectCreative, Navigation, Pagination } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
import 'swiper/css/effect-creative'
import clsx from 'clsx'
import { useTheme } from '@/components/ThemeProvider'

const ReviewSliderBrand = ({ isWhitePage }: { isWhitePage?: boolean }) => {
  const { theme } = useTheme()
  const items: ReviewSliderItemInterface[] = [
    {
      quotesColor: '#ff3e2d',
      review:
        'I had way too many photos on my phone and kept putting off sorting them. This app made it so much easier. The swipe feature is really helpful, and I actually started to enjoy going through my old pics. It’s not perfect, but it does the job well.',
      author: {
        img: '/img/reviews/1-new.png',
        text: 'photojunkie88',
      },
      publishedAt: 'March 12, 2025',
      gradientBg:
        'linear-gradient(180deg, rgba(14, 14, 15, 0.24) 0%, rgba(133, 14, 147, 0.24) 100%)',
    },
    {
      quotesColor: '#5c73ff',
      review:
        'Honestly didn’t expect much, but this app surprised me. It’s simple to use and helped me clean up a ton of junk photos in just a few minutes. I like that it saves where I left off, so I can do a little at a time. Makes the whole process really easy.',
      author: {
        img: '/img/reviews/2-new.png',
        text: 'mel_sanders',
      },
      publishedAt: 'April 4, 2025',
      gradientBg:
        'linear-gradient(180deg, rgba(14, 14, 15, 0.24) 0%, rgba(29, 43, 219, 0.24) 100%)',
    },
    {
      quotesColor: '#56e499',
      review:
        'I downloaded this because I was running out of storage, and it really helped. Deleting photos was way faster than doing it manually. It’s not fancy, but it’s straightforward and works well. Glad I found it.',
      author: {
        img: '/img/reviews/3-new.png',
        text: 'techdad_23',
      },
      publishedAt: 'May 1, 2025',
      gradientBg:
        'linear-gradient(180deg, rgba(14, 14, 15, 0.32) 0%, rgba(92, 54, 192, 0.32) 100%)',
    },
  ]
  return (
    <section className="relative max-w-[430px] ml-[-1rem] px-[1rem] overflow-hidden w-screen mb-8">
      <h2 className="mb-6 text-center font-bold text-XL">Our users love us</h2>
      <div className="w-screen max-w-[430px] -ml-4 px-7 overflow-visible">
        <Swiper
          spaceBetween={16}
          modules={[Navigation, Pagination, EffectCreative]}
          slidesPerView={1}
          initialSlide={1}
          className="!pb-10 flex !overflow-visible"
          pagination={{ clickable: true }}
        >
          {items.map((item, index) => (
            <SwiperSlide key={index} className="!h-auto">
              <div
                className={clsx(
                  'w-full h-full dark:bg-bg rounded-3xl p-[15px] flex flex-col items-center gap-4 relative before:backdrop-blur-[24px] before:absolute  before:content-[""] before:z-[-1] before:-left-px before:-right-px before:-top-px before:-bottom-px border border-[#3947E6] bg-[#FBFBFBA3] dark:border-none  dark:before:bg-borgerLightGradient before:rounded-3xl',
                  {
                    'review-light': isWhitePage,
                  },
                )}
                style={{ backgroundImage: theme === 'dark' ? item.gradientBg : 'none' }}
              >
                {theme === 'dark' ? (
                  <svg
                    width="100"
                    height="28"
                    viewBox="0 0 100 28"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M7.10326 13.817C7.47008 13.0737 8.52992 13.0737 8.89674 13.817L10.1185 16.2925C10.2641 16.5876 10.5457 16.7922 10.8714 16.8395L13.6033 17.2365C14.4235 17.3557 14.751 18.3637 14.1575 18.9422L12.1807 20.8691C11.945 21.0988 11.8375 21.4298 11.8931 21.7542L12.3598 24.4751C12.4999 25.292 11.6424 25.9149 10.9088 25.5293L8.46534 24.2446C8.17402 24.0915 7.82598 24.0915 7.53466 24.2446L5.09119 25.5293C4.35756 25.9149 3.50013 25.292 3.64024 24.4751L4.1069 21.7542C4.16254 21.4298 4.05499 21.0988 3.81931 20.8691L1.8425 18.9422C1.24898 18.3637 1.57649 17.3557 2.39671 17.2365L5.12859 16.8395C5.4543 16.7922 5.73587 16.5876 5.88153 16.2925L7.10326 13.817Z"
                      fill="url(#paint0_radial_745_2693)"
                    />
                    <path
                      d="M25.1033 9.81699C25.4701 9.07374 26.5299 9.07374 26.8967 9.81699L28.7063 13.4835C28.8519 13.7786 29.1335 13.9832 29.4592 14.0305L33.5054 14.6185C34.3256 14.7376 34.6531 15.7456 34.0596 16.3242L31.1318 19.1781C30.8961 19.4079 30.7885 19.7389 30.8442 20.0632L31.5353 24.0931C31.6754 24.91 30.818 25.533 30.0844 25.1473L26.4653 23.2446C26.174 23.0915 25.826 23.0915 25.5347 23.2446L21.9156 25.1473C21.182 25.533 20.3246 24.91 20.4647 24.0931L21.1558 20.0632C21.2115 19.7389 21.1039 19.4079 20.8682 19.1781L17.9404 16.3242C17.3469 15.7456 17.6744 14.7376 18.4946 14.6185L22.5408 14.0305C22.8665 13.9832 23.1481 13.7786 23.2937 13.4835L25.1033 9.81699Z"
                      fill="url(#paint1_radial_745_2693)"
                    />
                    <path
                      d="M49.1033 1.81699C49.4701 1.07374 50.5299 1.07374 50.8967 1.81699L53.8818 7.86544C54.0275 8.16058 54.3091 8.36515 54.6348 8.41248L61.3096 9.38239C62.1298 9.50158 62.4574 10.5096 61.8638 11.0881L57.0339 15.7962C56.7982 16.0259 56.6906 16.3569 56.7463 16.6813L57.8865 23.3292C58.0266 24.1461 57.1691 24.769 56.4355 24.3834L50.4653 21.2446C50.174 21.0915 49.826 21.0915 49.5347 21.2446L43.5645 24.3834C42.8309 24.769 41.9734 24.1461 42.1135 23.3292L43.2537 16.6813C43.3094 16.3569 43.2018 16.0259 42.9661 15.7962L38.1362 11.0881C37.5426 10.5096 37.8702 9.50158 38.6904 9.38239L45.3652 8.41248C45.6909 8.36515 45.9725 8.16058 46.1182 7.86544L49.1033 1.81699Z"
                      fill="url(#paint2_radial_745_2693)"
                    />
                    <path
                      d="M73.1033 9.81699C73.4701 9.07374 74.5299 9.07374 74.8967 9.81699L76.7063 13.4835C76.8519 13.7786 77.1335 13.9832 77.4592 14.0305L81.5054 14.6185C82.3256 14.7376 82.6531 15.7456 82.0596 16.3242L79.1318 19.1781C78.8961 19.4079 78.7885 19.7389 78.8442 20.0632L79.5353 24.0931C79.6754 24.91 78.818 25.533 78.0844 25.1473L74.4653 23.2446C74.174 23.0915 73.826 23.0915 73.5347 23.2446L69.9156 25.1473C69.182 25.533 68.3246 24.91 68.4647 24.0931L69.1558 20.0632C69.2115 19.7389 69.1039 19.4079 68.8682 19.1781L65.9404 16.3242C65.3469 15.7456 65.6744 14.7376 66.4946 14.6185L70.5408 14.0305C70.8665 13.9832 71.1481 13.7786 71.2937 13.4835L73.1033 9.81699Z"
                      fill="url(#paint3_radial_745_2693)"
                    />
                    <path
                      d="M91.1033 13.817C91.4701 13.0737 92.5299 13.0737 92.8967 13.817L94.1185 16.2925C94.2641 16.5876 94.5457 16.7922 94.8714 16.8395L97.6033 17.2365C98.4235 17.3557 98.751 18.3637 98.1575 18.9422L96.1807 20.8691C95.945 21.0988 95.8375 21.4298 95.8931 21.7542L96.3598 24.4751C96.4999 25.292 95.6424 25.9149 94.9088 25.5293L92.4653 24.2446C92.174 24.0915 91.826 24.0915 91.5347 24.2446L89.0912 25.5293C88.3576 25.9149 87.5001 25.292 87.6402 24.4751L88.1069 21.7542C88.1625 21.4298 88.055 21.0988 87.8193 20.8691L85.8425 18.9422C85.249 18.3637 85.5765 17.3557 86.3967 17.2365L89.1286 16.8395C89.4543 16.7922 89.7359 16.5876 89.8815 16.2925L91.1033 13.817Z"
                      fill="url(#paint4_radial_745_2693)"
                    />
                    <defs>
                      <radialGradient
                        id="paint0_radial_745_2693"
                        cx="0"
                        cy="0"
                        r="1"
                        gradientUnits="userSpaceOnUse"
                        gradientTransform="translate(8 12) rotate(90) scale(16)"
                      >
                        <stop offset="0.153846" stopColor="#FFEC99" />
                        <stop offset="0.298077" stopColor="#FFD13F" />
                        <stop offset="0.576923" stopColor="#FFBB00" />
                        <stop offset="0.764423" stopColor="#DB9A00" />
                      </radialGradient>
                      <radialGradient
                        id="paint1_radial_745_2693"
                        cx="0"
                        cy="0"
                        r="1"
                        gradientUnits="userSpaceOnUse"
                        gradientTransform="translate(26 8) rotate(90) scale(20)"
                      >
                        <stop offset="0.153846" stopColor="#FFEC99" />
                        <stop offset="0.298077" stopColor="#FFD13F" />
                        <stop offset="0.576923" stopColor="#FFBB00" />
                        <stop offset="0.764423" stopColor="#DB9A00" />
                      </radialGradient>
                      <radialGradient
                        id="paint2_radial_745_2693"
                        cx="0"
                        cy="0"
                        r="1"
                        gradientUnits="userSpaceOnUse"
                        gradientTransform="translate(50) rotate(90) scale(28)"
                      >
                        <stop offset="0.153846" stopColor="#FFEC99" />
                        <stop offset="0.298077" stopColor="#FFD13F" />
                        <stop offset="0.576923" stopColor="#FFBB00" />
                        <stop offset="0.764423" stopColor="#DB9A00" />
                      </radialGradient>
                      <radialGradient
                        id="paint3_radial_745_2693"
                        cx="0"
                        cy="0"
                        r="1"
                        gradientUnits="userSpaceOnUse"
                        gradientTransform="translate(74 8) rotate(90) scale(20)"
                      >
                        <stop offset="0.153846" stopColor="#FFEC99" />
                        <stop offset="0.298077" stopColor="#FFD13F" />
                        <stop offset="0.576923" stopColor="#FFBB00" />
                        <stop offset="0.764423" stopColor="#DB9A00" />
                      </radialGradient>
                      <radialGradient
                        id="paint4_radial_745_2693"
                        cx="0"
                        cy="0"
                        r="1"
                        gradientUnits="userSpaceOnUse"
                        gradientTransform="translate(92 12) rotate(90) scale(16)"
                      >
                        <stop offset="0.153846" stopColor="#FFEC99" />
                        <stop offset="0.298077" stopColor="#FFD13F" />
                        <stop offset="0.576923" stopColor="#FFBB00" />
                        <stop offset="0.764423" stopColor="#DB9A00" />
                      </radialGradient>
                    </defs>
                  </svg>
                ) : (
                  <svg
                    width="100"
                    height="28"
                    viewBox="0 0 100 28"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M7.10326 13.817C7.47008 13.0737 8.52992 13.0737 8.89674 13.817L10.1185 16.2925C10.2641 16.5876 10.5457 16.7922 10.8714 16.8395L13.6033 17.2365C14.4235 17.3557 14.751 18.3637 14.1575 18.9422L12.1807 20.8691C11.945 21.0988 11.8375 21.4298 11.8931 21.7542L12.3598 24.4751C12.4999 25.292 11.6424 25.9149 10.9088 25.5293L8.46534 24.2446C8.17402 24.0915 7.82598 24.0915 7.53466 24.2446L5.09119 25.5293C4.35756 25.9149 3.50013 25.292 3.64024 24.4751L4.1069 21.7542C4.16254 21.4298 4.05499 21.0988 3.81931 20.8691L1.8425 18.9422C1.24898 18.3637 1.57649 17.3557 2.39671 17.2365L5.12859 16.8395C5.4543 16.7922 5.73587 16.5876 5.88153 16.2925L7.10326 13.817Z"
                      fill="url(#paint0_radial_745_1417)"
                    />
                    <path
                      d="M25.1033 9.81699C25.4701 9.07374 26.5299 9.07374 26.8967 9.81699L28.7063 13.4835C28.8519 13.7786 29.1335 13.9832 29.4592 14.0305L33.5054 14.6185C34.3256 14.7376 34.6531 15.7456 34.0596 16.3242L31.1318 19.1781C30.8961 19.4079 30.7885 19.7389 30.8442 20.0632L31.5353 24.0931C31.6754 24.91 30.818 25.533 30.0844 25.1473L26.4653 23.2446C26.174 23.0915 25.826 23.0915 25.5347 23.2446L21.9156 25.1473C21.182 25.533 20.3246 24.91 20.4647 24.0931L21.1558 20.0632C21.2115 19.7389 21.1039 19.4079 20.8682 19.1781L17.9404 16.3242C17.3469 15.7456 17.6744 14.7376 18.4946 14.6185L22.5408 14.0305C22.8665 13.9832 23.1481 13.7786 23.2937 13.4835L25.1033 9.81699Z"
                      fill="url(#paint1_radial_745_1417)"
                    />
                    <path
                      d="M49.1033 1.81699C49.4701 1.07374 50.5299 1.07374 50.8967 1.81699L53.8818 7.86544C54.0275 8.16058 54.3091 8.36515 54.6348 8.41248L61.3096 9.38239C62.1298 9.50158 62.4574 10.5096 61.8638 11.0881L57.0339 15.7962C56.7982 16.0259 56.6906 16.3569 56.7463 16.6813L57.8865 23.3292C58.0266 24.1461 57.1691 24.769 56.4355 24.3834L50.4653 21.2446C50.174 21.0915 49.826 21.0915 49.5347 21.2446L43.5645 24.3834C42.8309 24.769 41.9734 24.1461 42.1135 23.3292L43.2537 16.6813C43.3094 16.3569 43.2018 16.0259 42.9661 15.7962L38.1362 11.0881C37.5426 10.5096 37.8702 9.50158 38.6904 9.38239L45.3652 8.41248C45.6909 8.36515 45.9725 8.16058 46.1182 7.86544L49.1033 1.81699Z"
                      fill="url(#paint2_radial_745_1417)"
                    />
                    <path
                      d="M73.1033 9.81699C73.4701 9.07374 74.5299 9.07374 74.8967 9.81699L76.7063 13.4835C76.8519 13.7786 77.1335 13.9832 77.4592 14.0305L81.5054 14.6185C82.3256 14.7376 82.6531 15.7456 82.0596 16.3242L79.1318 19.1781C78.8961 19.4079 78.7885 19.7389 78.8442 20.0632L79.5353 24.0931C79.6754 24.91 78.818 25.533 78.0844 25.1473L74.4653 23.2446C74.174 23.0915 73.826 23.0915 73.5347 23.2446L69.9156 25.1473C69.182 25.533 68.3246 24.91 68.4647 24.0931L69.1558 20.0632C69.2115 19.7389 69.1039 19.4079 68.8682 19.1781L65.9404 16.3242C65.3469 15.7456 65.6744 14.7376 66.4946 14.6185L70.5408 14.0305C70.8665 13.9832 71.1481 13.7786 71.2937 13.4835L73.1033 9.81699Z"
                      fill="url(#paint3_radial_745_1417)"
                    />
                    <path
                      d="M91.1033 13.817C91.4701 13.0737 92.5299 13.0737 92.8967 13.817L94.1185 16.2925C94.2641 16.5876 94.5457 16.7922 94.8714 16.8395L97.6033 17.2365C98.4235 17.3557 98.751 18.3637 98.1575 18.9422L96.1807 20.8691C95.945 21.0988 95.8375 21.4298 95.8931 21.7542L96.3598 24.4751C96.4999 25.292 95.6424 25.9149 94.9088 25.5293L92.4653 24.2446C92.174 24.0915 91.826 24.0915 91.5347 24.2446L89.0912 25.5293C88.3576 25.9149 87.5001 25.292 87.6402 24.4751L88.1069 21.7542C88.1625 21.4298 88.055 21.0988 87.8193 20.8691L85.8425 18.9422C85.249 18.3637 85.5765 17.3557 86.3967 17.2365L89.1286 16.8395C89.4543 16.7922 89.7359 16.5876 89.8815 16.2925L91.1033 13.817Z"
                      fill="url(#paint4_radial_745_1417)"
                    />
                    <defs>
                      <radialGradient
                        id="paint0_radial_745_1417"
                        cx="0"
                        cy="0"
                        r="1"
                        gradientUnits="userSpaceOnUse"
                        gradientTransform="translate(8 12) rotate(90) scale(16)"
                      >
                        <stop stopColor="#A599FF" />
                        <stop offset="0.298077" stopColor="#3F75FF" />
                        <stop offset="0.576923" stopColor="#0048FF" />
                        <stop offset="0.764423" stopColor="#002CDB" />
                      </radialGradient>
                      <radialGradient
                        id="paint1_radial_745_1417"
                        cx="0"
                        cy="0"
                        r="1"
                        gradientUnits="userSpaceOnUse"
                        gradientTransform="translate(26 8) rotate(90) scale(20)"
                      >
                        <stop stopColor="#A599FF" />
                        <stop offset="0.298077" stopColor="#3F75FF" />
                        <stop offset="0.576923" stopColor="#0048FF" />
                        <stop offset="0.764423" stopColor="#002CDB" />
                      </radialGradient>
                      <radialGradient
                        id="paint2_radial_745_1417"
                        cx="0"
                        cy="0"
                        r="1"
                        gradientUnits="userSpaceOnUse"
                        gradientTransform="translate(50) rotate(90) scale(28)"
                      >
                        <stop stopColor="#A599FF" />
                        <stop offset="0.298077" stopColor="#3F75FF" />
                        <stop offset="0.576923" stopColor="#0048FF" />
                        <stop offset="0.764423" stopColor="#002CDB" />
                      </radialGradient>
                      <radialGradient
                        id="paint3_radial_745_1417"
                        cx="0"
                        cy="0"
                        r="1"
                        gradientUnits="userSpaceOnUse"
                        gradientTransform="translate(74 8) rotate(90) scale(20)"
                      >
                        <stop stopColor="#A599FF" />
                        <stop offset="0.298077" stopColor="#3F75FF" />
                        <stop offset="0.576923" stopColor="#0048FF" />
                        <stop offset="0.764423" stopColor="#002CDB" />
                      </radialGradient>
                      <radialGradient
                        id="paint4_radial_745_1417"
                        cx="0"
                        cy="0"
                        r="1"
                        gradientUnits="userSpaceOnUse"
                        gradientTransform="translate(92 12) rotate(90) scale(16)"
                      >
                        <stop stopColor="#A599FF" />
                        <stop offset="0.298077" stopColor="#3F75FF" />
                        <stop offset="0.576923" stopColor="#0048FF" />
                        <stop offset="0.764423" stopColor="#002CDB" />
                      </radialGradient>
                    </defs>
                  </svg>
                )}

                <p className="text-ML text-center leading-[1.35]">{item.review}</p>
                <div className="flex flex-row items-center gap-4">
                  <figure className="relative w-[35px] h-[35px]">
                    <img
                      src={item.author.img}
                      alt={item.author.text}
                      className="absolute max-w-8 w-full block object-contain"
                    />
                    <span className="w-3 h-3 dark:[&_path]:stroke-bg [&_path]:stroke-[#FBFBFBA3] bg-[#3947E6] dark:bg-[#FFE20A] rounded-full flex items-center justify-center absolute bottom-0 right-0">
                      <svg
                        width="6"
                        height="6"
                        viewBox="0 0 6 6"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M0.5 3.33333L2.0625 5L5.5 1"
                          stroke="currenColor"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </span>
                  </figure>

                  <div className="flex flex-col items-center">
                    <p className="text-[13px] text-reviewAuthor">{item.author.text}</p>
                    <p className=" mt-0.5 text-reviewData text-S">{item.publishedAt}</p>
                  </div>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  )
}

export default ReviewSliderBrand
